import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import ApplicationsCard03 from '../../partials/application/ApplicationCard03'
import { Auth, API } from 'aws-amplify';
import AlertModal from '../AlertModal'
import ShopifyIcon from '../../images/shopify.png'
import WebsiteIcon from '../../images/website.png'

import jBox from 'jbox'
import 'jbox/dist/jBox.all.css';

function IntegrationsAdd({empushyIntegrations, activeIntegrations, userDetails}) {

  let history = useHistory();
  const [sync, setSync] = useState(false);
  const [integrationCards, setIntegrationCards] = useState('')
  const [alertModalState, setAlertModalState] = useState(null)

  useEffect(() => {
    OnLoad();
  }, [activeIntegrations]);

  function OnLoad() {
    Auth.currentSession().then(response => {
      var token = response.idToken.jwtToken
      arrangeIntegrationCards(token)
    }).catch( (error) => {
      history.push('/signin')
    });
  }

  function arrangeIntegrationCards(token){
    setIntegrationCards(empushyIntegrations.map(integration => {
      var isActive = false
      var activeId = 0
      for(var item of activeIntegrations){
        if(integration.id === item.integrationId) {
          isActive = true
          activeId = item.id
          break
        }
      }
      return (
          <ApplicationsCard03
              key={integration.id}
              id={integration.id}
              integrationId={integration.id}
              activeId={activeId}
              title={integration.name}
              isActive={isActive}
              onClick={syncIntegration}
              authToken={token}
              userDetails={userDetails}
          />
      )
    }))
  }

  const syncIntegration = (integrationId, activeId, name, isActive, userDetails, authToken) => {

    if(isActive && authToken!=null){
      disconnect(activeId, name, userDetails, authToken)
    }
    else {
      switch (name){
        case 'Website':
          connectWebsite()
          break
        case 'HubSpot':
          window.location.href = 'https://app.hubspot.com/oauth/authorize?client_id=2f52645d-e41a-4a1f-8406-6f5f94e8b412&' +
            'redirect_uri=https://dashboard.empushy.com/callback/hubspot' +
              '&scope=crm.objects.contacts.read%20crm.lists.read%20content%20business-intelligence%20sales-email-read%20oauth'
              // '&optional_scope=crm.objects.marketing_events.read%20crm.objects.marketing_events.write'
          break
        case 'Intercom':
          window.location.href = 'https://app.intercom.com/oauth?client_id=ac97f5cc-9250-49e8-a1d3-691312a2f6b1'
          break
        case 'Wix':
          window.location.href = 'https://www.wix.com/installer/install?appId=aa1bbf31-242b-4679-9f6e-88ac06229300&' +
            'redirectUrl=https://dashboard.empushy.com/callback/wix'
          break
        case 'SquareUp':
          window.location.href = 'https://connect.squareup.com/oauth2/authorize?client_id=sq0idp-W2hSN3bbshmCh94WFBpxSw' +
            '&scope=ITEMS_READ+ONLINE_STORE_SITE_READ&session=false&state=82201dd8d83d23cc8a48caf52b'
          break
        case 'Shopify':
          connectShopify()
          break
        case 'SquareSpace':
          window.location.href = 'https://login.squarespace.com/api/1/login/oauth/provider/authorize?' +
            'client_id=z0Uplu9wo80II7IXaqebgGuaLUVEE8S8&' +
            'scope=website.products.read,website.transactions.read,website.orders.read&' +
            'redirect_uri=https://dashboard.empushy.com/callback/squarespace&' +
            'state=82201dd8d83d23cc8a48caf52b&' +
            'access_type=offline'
          break
        case 'Shift4Shop':
          window.location.href = 'https://apirest.3dcart.com/oauth/authorize?' +
            'client_id=9664e07dca2937131d1388424479dc66&' +
            'redirect_uri=https://dashboard.empushy.com/callback/shift4shop&' +
            'state=z0Uplu9wo80II7IXaqebgGuaLUVEE8S8&' +
            'response_type=code'
          break
        case 'BigCommerce':
          new jBox('Confirm', {
            title: 'Install BigCommerce',
            content: 'EmPushy can be installed from your BigCommerce Admin Dashboard. Open your store dashboard by clicking the button below. ' +
              'Select Apps from the left menu. Search for the EmPushy app. Click the Install button. ' +
              'Wait for confirmation and you\'re all set!',
            confirmButton: 'Open BigCommerce',
            animation: {open: 'pulse', close: 'flip'},
            confirm: ()=>{window.open('https://login.bigcommerce.com/login', "bigcommerce", "popup")}
          }).open();
          break
        default:
          setAlertModalState({title: '👀 Coming Soon', message: 'We\'re working hard to support this app. Check back soon.'})
      }
    }
  }

  function disconnect(activeId, name, userDetails, authToken){

    switch (name){
      case 'HubSpot':
        var path = '/hubspot/disconnect';
        break
      case 'Intercom':
        var path = '/intercom/disconnect';
        break
      default:
        setAlertModalState({title: 'Oops', message: 'We could not disconnect right now. Try again later.'})
        return
    }
    const apiName = 'IntegrationAPI'; // replace this with your api name.
    const request = {
      body: {
        activeId: activeId,
        clientId: userDetails.clientId
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .post(apiName, path, request)
      .then(response => {
        history.push('/?status=disconnected')
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  function connectShopify(){
    var content = '<div class="col-span-full sm:col-span-6 xl:col-span-3 bg-white shadow-lg rounded-sm border border-gray-200">'+
      '<div class="flex flex-col h-full text-center p-5">'+
      '<div class="flex-grow mb-1">'+
      '<div class="inline-flex justify-center items-center w-16 h-16 bg-gray-100 rounded-full mb-2">'+
      '<img id="shopifyIcon" class="rounded-full bg-white" src="" width="100" height="100" alt="Shopify Icon" />'+
      '</div>'+
      '<h3 class="text-lg text-gray-800 font-semibold mb-1">Shopify</h3>'+
      '</div>'+
      '<div>'+
      '<input type="text" id="shopifyStore" placeholder="My shop name">'+
      '</div>'+
      '</div>'+
      '</div>'

    var connectShopifyModal = new jBox("Confirm",{
      id: "jBoxLogin",
      width: 320,
      height: 350,
      blockScrollAdjust: ["header"],
      confirmButton: 'Sync Shop',
      content: content,
      onOpen: function() {
        document.getElementById('shopifyIcon').setAttribute("src", ShopifyIcon)
      },
      confirm: function() {
        var shop = document.getElementById('shopifyStore').value
        if(shop!==undefined && shop!==''){
          shop = shop.replace('.myshopify.com', '')
          window.location.href = 'https://'+shop+'.myshopify.com/admin/oauth/authorize?client_id=d8a753a543933ff2a7e2ed575daf692a' +
          '&scope=read_content,read_customers,read_marketing_events,read_products&redirect_uri=https://dashboard.empushy.com/callback/shopify' +
          '&state=nonce'
        }
        connectShopifyModal.destroy()
      },
      cancel: function() {
        connectShopifyModal.destroy()
      }
    })
    connectShopifyModal.open()
  }

  function connectWebsite(){
    var content = '<div class="col-span-full sm:col-span-6 xl:col-span-3 bg-white shadow-lg rounded-sm border border-gray-200">'+
      '<div class="flex flex-col h-full text-center p-5">'+
      '<div class="flex-grow mb-1">'+
      '<div class="inline-flex justify-center items-center w-16 h-16 bg-gray-100 rounded-full mb-2">'+
      '<img id="websiteIcon" class="rounded-full bg-white" src="" width="100" height="100" alt="Shopify Icon" />'+
      '</div>'+
      '<h3 class="text-lg text-gray-800 font-semibold mb-1">My Website</h3>'+
      '</div>'+
      '<div>'+
      '<input type="text" style="width: 100%" id="websiteURL" placeholder="https://www.myepicwebsite.com">'+
      '</div>'+
      '</div>'+
      '</div>'

    var connectWebsiteModal = new jBox("Confirm",{
      id: "jBoxLogin",
      width: 400,
      height: 350,
      blockScrollAdjust: ["header"],
      confirmButton: 'Connect Website',
      content: content,
      onOpen: function() {
        document.getElementById('websiteIcon').setAttribute("src", WebsiteIcon)
      },
      confirm: function() {
        var url = document.getElementById('websiteURL').value
        if(url!=undefined && url!=''){
          url = url.replace('https://', '').replace('http://', '')
          console.log(url)
        }
        connectWebsiteModal.destroy()
      },
      cancel: function() {
        connectWebsiteModal.destroy()
      }
    })
    connectWebsiteModal.open()
  }

  return (
    <div className="flex-grow">
      <div className="p-6 space-y-6">
        <div>
          <div className="mt-8">
            <div className="grid grid-cols-12 gap-6">
              {
                integrationCards
              }
            </div>
          </div>
        </div>
      </div>
      <AlertModal params={alertModalState} toggleState={setAlertModalState}/>
    </div>
  );
}

export default IntegrationsAdd;